// collectionPaths.js — canonical in-app paths for collections (née databases)

/**
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function normalizeAppearAsQueryValue(value) {
  return String(value || '').trim().toLowerCase();
}

/**
 * Build the app route for a collection (structured list of one type).
 * Legacy `/database/:id` remains routed for compatibility.
 *
 * @param {string} collectionKey
 * @param {{ module?: string, appearAs?: string }} [options]
 * @returns {string}
 */
export function buildCollectionPath(collectionKey, options = {}) {
  const key = String(collectionKey || '').trim();
  if (!key) return '/';

  const params = new URLSearchParams();
  const moduleParam = String(options?.module || '').trim().toLowerCase();
  if (moduleParam === 'public' || moduleParam === 'private') {
    params.set('module', moduleParam);
  }
  const appearAs = normalizeAppearAsQueryValue(options?.appearAs);
  if (appearAs) params.set('appearAs', appearAs);

  const query = params.toString();
  return query ? `/collection/${key}?${query}` : `/collection/${key}`;
}

/**
 * @param {string} search
 * @returns {string}
 */
export function getAppearAsKeyFromSearch(search) {
  const raw = String(search || '');
  const query = raw.startsWith('?') ? raw.slice(1) : raw;
  try {
    return normalizeAppearAsQueryValue(new URLSearchParams(query).get('appearAs'));
  } catch {
    return '';
  }
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isCollectionRoutePath(pathname) {
  const path = String(pathname || '');
  return path.startsWith('/collection/') || path.startsWith('/database/');
}

/**
 * @param {string} pathname
 * @returns {string|null}
 */
export function getCollectionKeyFromPath(pathname) {
  const path = String(pathname || '');
  const match = path.match(/^\/(?:collection|database)\/([^/]+)/);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}
